import styled, {css, keyframes} from "styled-components";

const rotationKF = keyframes`
    0% {
        --deg: 15deg;
    }
    100% {
        --deg: 375deg;
    }
`;

export const ConicShadowDefaultBox = styled.div<{show?: boolean; background: string}>`
    @property --deg {
        syntax: "<angle>";
        inherits: false;
        initial-value: 0deg;
    }
    --deg: 15deg;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: -1;
    border-radius: 50px;

    opacity: ${props => props.show ? 0.7 : 0};
    background: ${props => props.background};
    ${props => props.show ? css`
        animation: ${rotationKF} 10s linear infinite normal none;
    ` : null};
    filter: blur(9px);
`;